import { post } from './apiService';

export const getLoginUrlToken = async (email) => {
  return await post('hb-login');

};